import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "@/lib/i18n";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("gdas_lang") || "es");
  useEffect(() => {
    localStorage.setItem("gdas_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const value = useMemo(() => {
    const t = (k) => translations[lang][k] ?? k;
    const toggle = () => setLang((l) => (l === "es" ? "en" : "es"));
    return { lang, setLang, toggle, t };
  }, [lang]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
